import React, { useState, useEffect, useRef  } from 'react';
 
import { BrowserRouter as Router,  useNavigate } from 'react-router-dom';
import './Header.css'
import axios from 'axios';
import logo from '../../assets/images/logo.png';
import { Navbar, Nav, Container } from 'react-bootstrap';
import SearchIcon from '../../assets/images/icons/search-icon.svg';
import ScrollToTop from '../ScrollToTop';
import Loader from "../../components/Loader";
 
export default function Header() {
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [navLinks, setNavLinks] = useState([]);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const searchRef = useRef(null);
 const lastScrollY = useRef(0);
  const ticking = useRef(false);
  const [isVisible, setIsVisible] = useState(true);
  
  useEffect(() => {
    const fetchNavLinks = async () => {
      try {
        const response = await axios.get(window.$baseUrl + '/menu_items/main');
        
        setNavLinks(response.data);
      } catch (error) {
        console.error('Error fetching navigation links:', error);
      }
    };
    fetchNavLinks();
 
    // Check if the screen width is mobile-sized
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 991);
    };

    // Add resize event listener
    window.addEventListener('resize', handleResize);

    // Initial check
    handleResize();

    // Close search bar on outside click
    const handleOutsideClick = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setIsSearchOpen(false);
      }
    };
    document.addEventListener('click', handleOutsideClick);

    // Clean up event listener
    return () => {
      document.removeEventListener('click', handleOutsideClick);
      window.removeEventListener('resize', handleResize);
    } 
  }, []);


  useEffect(() => {
    const handleScroll = () => {
      if (!ticking.current) {
        window.requestAnimationFrame(() => {
          const currentScrollY = window.scrollY;
 
          // Show header when scrolling up
          if (currentScrollY < lastScrollY.current) {
            setIsVisible(true);
          }
          // Hide header when scrolling down (but not at the very top)
          else if (currentScrollY > lastScrollY.current && currentScrollY > 10) {
            setIsVisible(false);
          }
 
          lastScrollY.current = currentScrollY;
          ticking.current = false;
        });
 
        ticking.current = true;
      }
    };
 
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
 

  const fetchSearchResults = async (query) => {
    try {
      const response = await axios.get(
        window.$baseUrl + '${encodeURIComponent(query)}'
      );
      setSearchResults(response.data);
      if (window.innerWidth <= 991) {
    
        window.location.reload();
      }
    } catch (error) {
      console.error('Error fetching search results:', error);
    }
  };

  const handleKeyPress = async (event) => {
    setLoading(true);
    if (event.key === 'Enter' && searchQuery.trim() !== '') {
      await fetchSearchResults(searchQuery.trim());
      navigate(`/search?query=${encodeURIComponent(searchQuery.trim())}`);
      window.location.reload();
      setLoading(false);
    }
  };

  const handleInputChange = (event) => {
    setSearchQuery(event.target.value);
  };
  
  const toggleSearch = () => {
    setIsSearchOpen(!isSearchOpen);
  };
 
  const handleMouseEnter = (key) => {
    if (!isMobile) {
      setDropdownOpen(key);
    }
  };

  const handleMouseLeave = () => {
    if (!isMobile) {
      setDropdownOpen(null);
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    if (!isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  };

  const handleSubItemClick = () => {
    setIsMenuOpen(false);
    setDropdownOpen(null);
  };

  // Only toggle dropdown when clicking the arrow
  const handleArrowClick = (e, key) => {
    e.preventDefault();
    e.stopPropagation();
    if (isMobile) {
      setDropdownOpen(dropdownOpen === key ? null : key);
    }
  };

  return (
    <>
    
      <ScrollToTop />
      <Navbar expand="lg"  className={`sticky-header ${isVisible ? 'header-visible' : 'header-hidden'}`}>
        <Container fluid className='p-0'>
          <Navbar.Brand><a href="/">
            <img src={logo} alt="Logo" width="180" height="67" />
          </a></Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={toggleMenu} />
          <Navbar.Collapse id="basic-navbar-nav" className={isMenuOpen ? 'show' : ''}>
            <Nav className="ms-auto nav-fixed-height">
            
              {navLinks.length === 0 ? (
                <div className="menu-skeleton">
                  {[...Array(5)].map((_, i) => (
                    <span key={i}></span>
                  ))}
                </div>
              ) : (
                navLinks.map((link) => {
                  if (!link.enabled) return null;

                  const hasDropdown = link.field_submenu[0].value === "1" && link.below?.length > 0;

                  return hasDropdown ? (
                    <div
                      className={`nav-item dropdown ${dropdownOpen === link.key ? 'show' : ''}`}
                      key={link.key}
                      onMouseEnter={() => handleMouseEnter(link.key)}
                      onMouseLeave={handleMouseLeave}
                    >
                      <div className="dropdown-link-wrapper">
                        <a
                          href={link.relative}
                          className="nav-link"
                          onClick={() => {
                            setIsMenuOpen(false);
                            setDropdownOpen(null);
                          }}
                        >
                          {link.title}
                        </a>
                        
                        {/* Arrow button - only for toggling dropdown on mobile */}
                        {isMobile && (
                          <button
                            className="dropdown-toggle-btn"
                            onClick={(e) => handleArrowClick(e, link.key)}
                            aria-expanded={dropdownOpen === link.key}
                            aria-label="Toggle dropdown"
                          >
                            <span className="arrow-icon"></span>
                          </button>
                        )}

                        {/* Desktop arrow - just for display */}
                        {!isMobile && (
                          <span className="desktop-arrow"></span>
                        )}
                      </div>

                      <div className={`dropdown-menu ${dropdownOpen === link.key ? 'show' : ''}`}>
                        {link.below.map((subLink) => (
                          <a
                            key={subLink.key}
                            href={subLink.relative}
                            className="dropdown-item"
                            onClick={handleSubItemClick}
                          >
                            {subLink.title}
                          </a>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <a
                      key={link.key}
                      href={link.relative}
                      className="nav-link"
                      onClick={() => {
                        setIsMenuOpen(false);
                        setDropdownOpen(null);
                      }}
                    >
                      {link.title}
                    </a>
                  );
                })
              )}

              <div className={`search-section ms-0 ms-lg-3 ${isSearchOpen ? 'search-active' : ''}`} ref={searchRef}>
                <img
                  src={SearchIcon}
                  alt="Search"
                  width="30"
                  height="30"
                  className="search-icon"
                  onClick={toggleSearch}
                />
                {isSearchOpen && (
                  <input
                    type="text"
                    className="search-input"
                    placeholder="Search..."
                    onKeyDown={handleKeyPress}
                    value={searchQuery}
                    onChange={handleInputChange}
                    autoFocus
                  />
                )}
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}